import PulleysImg from '../../Images/PulleysImg.jpg'


const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #7a2e00', fontFamily:"'Georgia', serif", color:'#1a0e06', lineHeight:'1.7', background:'#fdf6ee' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c45a10', paddingBottom:'8px', marginBottom:'24px', color:'#7a2e00' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#a04010', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c45a10', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#fdf0e4', border:'2px solid #c45a10', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a2e00', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c45a10' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#a04010', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf4ec' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #e8c89a', verticalAlign:'top', background:'#fdf6ee' },
  tdL: { fontWeight:'600', color:'#7a2e00', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fdf4ec', border:'1px solid #e8b07a', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7a2e00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#7a4a28', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: Series Pulley System Overview ───────────────────────────
function DiagramSeriesOverview() {
  const W = 900, H = 340;

  // Pulley centres
  const pulleys = [
    { x: 120, y: 160, r: 55, label: 'Driver', sub: 'Input', n: 1 },
    { x: 340, y: 160, r: 38, label: 'P2', sub: 'Intermediate', n: 2 },
    { x: 520, y: 160, r: 28, label: 'P3', sub: 'Intermediate', n: 3 },
    { x: 680, y: 160, r: 45, label: 'Driven', sub: 'Output', n: 4 },
  ];

  // Belt wrap tangent lines between consecutive pulleys (approximate open belt)
  const beltSegs = [];
  for (let i = 0; i < pulleys.length - 1; i++) {
    const a = pulleys[i], b = pulleys[i + 1];
    const dx = b.x - a.x, dy = b.y - a.y;
    const d = Math.sqrt(dx*dx + dy*dy);
    const sina = (b.r - a.r) / d;
    const cosa = Math.sqrt(1 - sina*sina);
    // top tangent
    const ax1 = a.x + a.r * sina, ay1 = a.y - a.r * cosa;
    const bx1 = b.x + b.r * sina, by1 = b.y - b.r * cosa;
    // bottom tangent
    const ax2 = a.x - a.r * sina, ay2 = a.y + a.r * cosa;
    const bx2 = b.x - b.r * sina, by2 = b.y + b.r * cosa;
    beltSegs.push({ ax1, ay1, bx1, by1, ax2, ay2, bx2, by2 });
  }

  const shaftY = [260, 260, 260, 260];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Series (Compound) Pulley System — Multiple Stages on a Common Belt Line</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowG" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <radialGradient id="pulleyGrad" cx="40%" cy="35%">
            <stop offset="0%" stopColor="#e8b07a"/>
            <stop offset="100%" stopColor="#7a2e00"/>
          </radialGradient>
          <radialGradient id="pulleyGrad2" cx="40%" cy="35%">
            <stop offset="0%" stopColor="#aadaaa"/>
            <stop offset="100%" stopColor="#a04010"/>
          </radialGradient>
        </defs>

        {/* Shaft lines */}
        {pulleys.map((p, i) => (
          <line key={i} x1={p.x} y1={p.y + p.r + 4} x2={p.x} y2={shaftY[i]}
            stroke="#a04010" strokeWidth="3" strokeDasharray="6,3"/>
        ))}

        {/* Ground supports */}
        {pulleys.map((p, i) => (
          <g key={i}>
            <line x1={p.x - 18} y1={shaftY[i]} x2={p.x + 18} y2={shaftY[i]} stroke="#7a2e00" strokeWidth="3"/>
            {[-14,-7,0,7,14].map((dx,j) => (
              <line key={j} x1={p.x + dx} y1={shaftY[i]} x2={p.x + dx - 6} y2={shaftY[i] + 10}
                stroke="#7a2e00" strokeWidth="1.5"/>
            ))}
          </g>
        ))}

        {/* Belt segments */}
        {beltSegs.map((s, i) => (
          <g key={i}>
            <line x1={s.ax1} y1={s.ay1} x2={s.bx1} y2={s.by1} stroke="#c45a10" strokeWidth="4"/>
            <line x1={s.ax2} y1={s.ay2} x2={s.bx2} y2={s.by2} stroke="#c45a10" strokeWidth="4"/>
          </g>
        ))}

        {/* Pulleys */}
        {pulleys.map((p, i) => (
          <g key={i}>
            {/* Spoke details */}
            {[0,60,120,180,240,300].map((angle, j) => {
              const rad = angle * Math.PI / 180;
              return (
                <line key={j}
                  x1={p.x + (p.r * 0.25) * Math.cos(rad)}
                  y1={p.y + (p.r * 0.25) * Math.sin(rad)}
                  x2={p.x + (p.r * 0.8) * Math.cos(rad)}
                  y2={p.y + (p.r * 0.8) * Math.sin(rad)}
                  stroke="#7a2e00" strokeWidth="1.5" opacity="0.5"
                />
              );
            })}
            <circle cx={p.x} cy={p.y} r={p.r} fill="url(#pulleyGrad)" stroke="#7a2e00" strokeWidth="2.5"/>
            <circle cx={p.x} cy={p.y} r={p.r * 0.25} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
            <text x={p.x} y={p.y - p.r - 14} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">{p.label}</text>
            <text x={p.x} y={p.y - p.r - 3} textAnchor="middle" fontSize="9" fill="#a04010">{p.sub}</text>
            <text x={p.x} y={p.y + 5} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fdf4ec">D{p.n}</text>
          </g>
        ))}

        {/* Rotation arrows */}
        {pulleys.map((p, i) => {
          const r = p.r + 10;
          const cx = p.x, cy = p.y;
          const dir = i % 2 === 0 ? 1 : -1;
          const sweep = dir > 0 ? 1 : 0;
          return (
            <path key={i}
              d={`M ${cx + r} ${cy} A ${r} ${r} 0 0 ${sweep} ${cx} ${cy - r}`}
              fill="none" stroke="#d4874a" strokeWidth="1.5"
              markerEnd="url(#arrowG)" opacity="0.75"/>
          );
        })}

        {/* Input torque arrow */}
        <line x1={30} y1={160} x2={58} y2={160} stroke="#c45a10" strokeWidth="2.5" markerEnd="url(#arrowG)"/>
        <text x={14} y={145} fontSize="11" fontWeight="700" fill="#c45a10">τ_in</text>
        <text x={14} y={158} fontSize="10" fill="#a04010">F_in</text>

        {/* Output arrow */}
        <line x1={730} y1={160} x2={760} y2={160} stroke="#7a2e00" strokeWidth="2.5" markerEnd="url(#arrowG)"/>
        <text x={764} y={154} fontSize="11" fontWeight="700" fill="#7a2e00">τ_out</text>
        <text x={764} y={167} fontSize="10" fill="#7a2e00">ω_out</text>

        {/* Speed ratio annotation */}
        <rect x={320} y={290} width={260} height={36} rx={4} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={450} y={307} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">
          Overall Velocity Ratio = N₁/N₂ × N₃/N₄
        </text>
        <text x={450} y={320} textAnchor="middle" fontSize="9" fill="#a04010">
          (product of individual stage ratios)
        </text>

        <text x={W/2} y={H - 6} textAnchor="middle" fontSize="9" fill="#888" fontStyle="italic">
          Each intermediate shaft carries two pulleys — input stage drives output stage
        </text>
      </svg>
      <div style={S.dCaption}>Series pulley arrangement: multiple belt-and-pulley stages in sequence to achieve large overall speed or torque ratios</div>
    </div>
  );
}

// ── Diagram: Velocity Ratio & Speed Calculation ──────────────────────
function DiagramVelocityRatio() {
  const W = 900, H = 300;

  const stages = [
    { x: 100, yD: 90, rD: 52, ydn: 190, rdn: 30, label1: 'Driver D₁', label2: 'Driven d₁', speed1: 'N₁', speed2: 'N₂' },
    { x: 340, yD: 90, rD: 30, ydn: 190, rdn: 48, label1: 'Driver D₂', label2: 'Driven d₂', speed1: 'N₂', speed2: 'N₃' },
    { x: 560, yD: 90, rD: 48, ydn: 190, rdn: 22, label1: 'Driver D₃', label2: 'Driven d₃', speed1: 'N₃', speed2: 'N₄' },
  ];

  const arrows = [
    { x1: 195, x2: 295, y: 140, label: 'Stage 1 belt' },
    { x1: 415, x2: 465, y: 140, label: 'Shaft' },
    { x1: 635, x2: 720, y: 140, label: 'Stage 2 belt' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Velocity Ratio Calculation — Two-Stage Series System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowGS" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#a04010"/>
          </marker>
        </defs>

        {/* Stage 1: large driver drives small driven */}
        {/* Stage box outlines */}
        <rect x={30} y={40} width={260} height={230} rx={6} fill="none" stroke="#e8b07a" strokeDasharray="5,3" strokeWidth="1.5"/>
        <text x={160} y={30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#a04010">Stage 1 (Speed-Up)</text>

        <rect x={300} y={40} width={260} height={230} rx={6} fill="none" stroke="#e8b07a" strokeDasharray="5,3" strokeWidth="1.5"/>
        <text x={430} y={30} textAnchor="middle" fontSize="11" fontWeight="700" fill="#a04010">Stage 2 (Speed-Up)</text>

        {/* Stage 1 pulleys */}
        <circle cx={130} cy={140} r={52} fill="#c45a10" opacity="0.8" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={130} cy={140} r={14} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={130} y={135} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">D₁</text>
        <text x={130} y={148} textAnchor="middle" fontSize="9" fill="#f5d9be">Driver</text>
        <text x={130} y={205} textAnchor="middle" fontSize="9" fill="#a04010">r₁ = 52 mm</text>
        <text x={130} y={217} textAnchor="middle" fontSize="9" fill="#a04010">N₁ = 300 rpm</text>

        <circle cx={255} cy={140} r={30} fill="#d4874a" opacity="0.8" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={255} cy={140} r={9} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={255} y={135} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">d₁</text>
        <text x={255} y={148} textAnchor="middle" fontSize="9" fill="#f5d9be">Driven</text>
        <text x={255} y={205} textAnchor="middle" fontSize="9" fill="#a04010">r₁' = 30 mm</text>
        <text x={255} y={217} textAnchor="middle" fontSize="9" fill="#a04010">N₂ = 520 rpm</text>

        {/* Belt stage 1 */}
        <line x1={130} y1={88} x2={255} y2={110} stroke="#c45a10" strokeWidth="3.5"/>
        <line x1={130} y1={192} x2={255} y2={170} stroke="#c45a10" strokeWidth="3.5"/>

        {/* Stage 2 pulleys — on same shaft as d₁ */}
        {/* Shaft link */}
        <line x1={255} y1={140} x2={360} y2={140} stroke="#7a2e00" strokeWidth="5"/>
        <rect x={292} y={134} width={24} height={12} rx={3} fill="#e8b07a"/>
        <text x={304} y={145} textAnchor="middle" fontSize="8" fill="#7a2e00">shaft</text>

        <circle cx={395} cy={140} r={28} fill="#c45a10" opacity="0.8" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={395} cy={140} r={8} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={395} y={135} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">D₂</text>
        <text x={395} y={148} textAnchor="middle" fontSize="9" fill="#f5d9be">Driver</text>
        <text x={395} y={205} textAnchor="middle" fontSize="9" fill="#a04010">r₂ = 28 mm</text>
        <text x={395} y={217} textAnchor="middle" fontSize="9" fill="#a04010">N₂ = 520 rpm</text>

        <circle cx={530} cy={140} r={48} fill="#d4874a" opacity="0.8" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={530} cy={140} r={13} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={530} y={135} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff">d₂</text>
        <text x={530} y={148} textAnchor="middle" fontSize="9" fill="#f5d9be">Driven</text>
        <text x={530} y={205} textAnchor="middle" fontSize="9" fill="#a04010">r₂' = 48 mm</text>
        <text x={530} y={217} textAnchor="middle" fontSize="9" fill="#a04010">N₃ = 303 rpm</text>

        {/* Belt stage 2 */}
        <line x1={395} y1={112} x2={530} y2={92} stroke="#c45a10" strokeWidth="3.5"/>
        <line x1={395} y1={168} x2={530} y2={188} stroke="#c45a10" strokeWidth="3.5"/>

        {/* Formula panel */}
        <rect x={615} y={50} width={270} height={210} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={750} y={75} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Velocity Ratio Formula</text>
        <line x1={625} y1={82} x2={875} y2={82} stroke="#e8b07a" strokeWidth="1"/>

        {[
          ['Stage 1 VR:', 'VR₁ = D₁/d₁ = N₂/N₁'],
          ['Stage 1 VR:', '= 52/30 = 1.733'],
          ['', ''],
          ['Stage 2 VR:', 'VR₂ = D₂/d₂ = N₃/N₂'],
          ['Stage 2 VR:', '= 28/48 = 0.583'],
          ['', ''],
          ['Overall VR:', 'VR = VR₁ × VR₂'],
          ['', '= 1.733 × 0.583 ≈ 1.01'],
          ['', ''],
          ['Overall Speed:', 'N₃ = N₁ × VR = 303 rpm'],
        ].map(([label, value], i) => (
          <g key={i}>
            <text x={625} y={100 + i * 17} fontSize="9" fontWeight={label?'600':'400'} fill="#7a2e00">{label}</text>
            <text x={740} y={100 + i * 17} fontSize="9" fontFamily="'Courier New', monospace" fill="#a04010">{value}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>VR &gt; 1: speed reduction (torque multiplication) · VR &lt; 1: speed increase · Series stages multiply: VR_total = VR₁ × VR₂ × VR₃ …</div>
    </div>
  );
}

// ── Diagram: Belt Types ──────────────────────────────────────────────
function DiagramBeltTypes() {
  const W = 900, H = 320;
  // Each belt column: shape at y=30 area, labels below shape, comparison table at y=225

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Common Belt Cross-Sections Used in Pulley Systems</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Flat belt — shape centred at y=55 */}
        <g transform="translate(60,20)">
          <rect x={0} y={44} width={120} height={22} rx={3} fill="#c45a10" opacity="0.85"/>
          {/* width dim line below shape */}
          <line x1={0} y1={74} x2={120} y2={74} stroke="#e8b07a" strokeWidth="1"/>
          <line x1={0} y1={70} x2={0} y2={78} stroke="#e8b07a" strokeWidth="1"/>
          <line x1={120} y1={70} x2={120} y2={78} stroke="#e8b07a" strokeWidth="1"/>
          <text x={60} y={86} textAnchor="middle" fontSize="8" fill="#d4874a">width b</text>
          {/* thickness dim line to right */}
          <line x1={128} y1={44} x2={128} y2={66} stroke="#e8b07a" strokeWidth="1"/>
          <text x={138} y={58} fontSize="8" fill="#d4874a">t</text>
          {/* labels */}
          <text x={60} y={104} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Flat Belt</text>
          <text x={60} y={118} textAnchor="middle" fontSize="9" fill="#a04010">Rectangular section</text>
          <text x={60} y={130} textAnchor="middle" fontSize="9" fill="#a04010">Low cost, high speed</text>
          <text x={60} y={142} textAnchor="middle" fontSize="9" fill="#a04010">Efficiency ~96%</text>
        </g>

        {/* V-Belt — shape centred at y=55 */}
        <g transform="translate(280,20)">
          <polygon points="10,44 110,44 100,66 20,66" fill="#c45a10" opacity="0.85"/>
          {/* angle annotation */}
          <line x1={60} y1={44} x2={20} y2={66} stroke="#e8b07a" strokeWidth="1" strokeDasharray="3,2"/>
          <text x={4} y={60} fontSize="8" fill="#d4874a">40°</text>
          {/* labels */}
          <text x={60} y={95} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">V-Belt</text>
          <text x={60} y={109} textAnchor="middle" fontSize="9" fill="#a04010">Trapezoidal section</text>
          <text x={60} y={121} textAnchor="middle" fontSize="9" fill="#a04010">Wedge action → high grip</text>
          <text x={60} y={133} textAnchor="middle" fontSize="9" fill="#a04010">Efficiency ~96–98%</text>
        </g>

        {/* Timing belt — shape centred at y=55 */}
        <g transform="translate(500,20)">
          <rect x={0} y={44} width={120} height={22} rx={3} fill="#c45a10" opacity="0.85"/>
          {[10,26,42,58,74,90,106].map((tx, i) => (
            <rect key={i} x={tx} y={66} width={10} height={10} rx={2} fill="#7a2e00" opacity="0.9"/>
          ))}
          {/* labels — extra top margin because teeth extend down */}
          <text x={60} y={100} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Timing (Toothed)</text>
          <text x={60} y={114} textAnchor="middle" fontSize="9" fill="#a04010">Teeth mesh with grooves</text>
          <text x={60} y={126} textAnchor="middle" fontSize="9" fill="#a04010">No slip — synchronous</text>
          <text x={60} y={138} textAnchor="middle" fontSize="9" fill="#a04010">Efficiency ~98–99%</text>
        </g>

        {/* Round belt — circle centred at y=55 */}
        <g transform="translate(720,20)">
          <ellipse cx={60} cy={55} rx={22} ry={22} fill="#c45a10" opacity="0.85"/>
          {/* labels */}
          <text x={60} y={98} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7a2e00">Round Belt</text>
          <text x={60} y={112} textAnchor="middle" fontSize="9" fill="#a04010">Circular cross-section</text>
          <text x={60} y={124} textAnchor="middle" fontSize="9" fill="#a04010">Light loads, twisted drives</text>
          <text x={60} y={136} textAnchor="middle" fontSize="9" fill="#a04010">Used in small machines</text>
        </g>

        {/* Divider */}
        <line x1={20} y1={195} x2={880} y2={195} stroke="#e8c89a" strokeWidth="1" strokeDasharray="4,3"/>

        {/* Comparison table at bottom — starts at y=200, ends at y=310 */}
        <rect x={20} y={200} width={860} height={108} rx={4} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={40} y={218} fontSize="10" fontWeight="700" fill="#7a2e00">Key property comparison:</text>
        {[
          { x: 160, label: 'Flat', slip: 'Low–Med', power: 'Medium', install: 'Easy', speed: 'High (≤30 m/s)' },
          { x: 360, label: 'V-Belt', slip: 'Low', power: 'Med–High', install: 'Easy', speed: 'Med (≤25 m/s)' },
          { x: 570, label: 'Timing', slip: 'None', power: 'High', install: 'Moderate', speed: 'Med (≤20 m/s)' },
          { x: 770, label: 'Round', slip: 'Med', power: 'Low', install: 'Very Easy', speed: 'Low–Med' },
        ].map((b, i) => (
          <g key={i}>
            <text x={b.x} y={218} textAnchor="middle" fontSize="10" fontWeight="700" fill="#a04010">{b.label}</text>
            <text x={b.x} y={234} textAnchor="middle" fontSize="9" fill="#7a4a28">Slip: {b.slip}</text>
            <text x={b.x} y={248} textAnchor="middle" fontSize="9" fill="#7a4a28">Power: {b.power}</text>
            <text x={b.x} y={262} textAnchor="middle" fontSize="9" fill="#7a4a28">Install: {b.install}</text>
            <text x={b.x} y={276} textAnchor="middle" fontSize="9" fill="#7a4a28">Speed: {b.speed}</text>
          </g>
        ))}
        {/* Vertical dividers in table */}
        {[258, 462, 668].map((lx, i) => (
          <line key={i} x1={lx} y1={205} x2={lx} y2={303} stroke="#e8c89a" strokeWidth="1"/>
        ))}
      </svg>
      <div style={S.dCaption}>Belt selection depends on power, speed, slip tolerance, centre distance, and environmental conditions</div>
    </div>
  );
}

// ── Diagram: Open vs Crossed Belt ────────────────────────────────────
function DiagramBeltArrangement() {
  const W = 900, H = 260;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Open Belt vs Crossed Belt Drive — Direction of Rotation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowRot" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* OPEN BELT */}
        <text x={210} y={22} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7a2e00">Open Belt Drive</text>
        <text x={210} y={36} textAnchor="middle" fontSize="9" fill="#a04010">Rotation: SAME direction</text>

        <circle cx={110} cy={130} r={50} fill="#c45a10" opacity="0.75" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={110} cy={130} r={13} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={110} y={135} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">D</text>
        {/* CW arrow */}
        <path d="M 110 78 A 52 52 0 0 1 162 130" fill="none" stroke="#e8b07a" strokeWidth="1.8" markerEnd="url(#arrowRot)"/>

        <circle cx={310} cy={130} r={30} fill="#d4874a" opacity="0.75" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={310} cy={130} r={9} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={310} y={135} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">d</text>
        {/* CW arrow */}
        <path d="M 310 98 A 32 32 0 0 1 342 130" fill="none" stroke="#e8b07a" strokeWidth="1.8" markerEnd="url(#arrowRot)"/>

        {/* Open belt lines */}
        <line x1={110} y1={80} x2={310} y2={100} stroke="#c45a10" strokeWidth="3.5"/>
        <line x1={110} y1={180} x2={310} y2={160} stroke="#c45a10" strokeWidth="3.5"/>

        {/* Angle of wrap label */}
        <text x={110} y={222} textAnchor="middle" fontSize="9" fill="#7a4a28">Wrap angle α = 180° − 2sin⁻¹((D−d)/2C)</text>

        {/* Separator */}
        <line x1={450} y1={10} x2={450} y2={250} stroke="#e8b07a" strokeWidth="1" strokeDasharray="6,4"/>

        {/* CROSSED BELT */}
        <text x={680} y={22} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7a2e00">Crossed Belt Drive</text>
        <text x={680} y={36} textAnchor="middle" fontSize="9" fill="#a04010">Rotation: OPPOSITE direction</text>

        <circle cx={560} cy={130} r={50} fill="#c45a10" opacity="0.75" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={560} cy={130} r={13} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={560} y={135} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">D</text>
        <path d="M 560 78 A 52 52 0 0 1 612 130" fill="none" stroke="#e8b07a" strokeWidth="1.8" markerEnd="url(#arrowRot)"/>

        <circle cx={790} cy={130} r={30} fill="#d4874a" opacity="0.75" stroke="#7a2e00" strokeWidth="2"/>
        <circle cx={790} cy={130} r={9} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={790} y={135} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">d</text>
        {/* CCW arrow */}
        <path d="M 790 162 A 32 32 0 0 1 758 130" fill="none" stroke="#e8b07a" strokeWidth="1.8" markerEnd="url(#arrowRot)"/>

        {/* Crossed belt lines — cross in the middle */}
        <line x1={610} y1={80} x2={762} y2={160} stroke="#c45a10" strokeWidth="3.5"/>
        <line x1={610} y1={180} x2={762} y2={100} stroke="#c45a10" strokeWidth="3.5"/>
        {/* Cross point indicator */}
        <circle cx={686} cy={130} r={5} fill="#c45a10" stroke="#fdf4ec" strokeWidth="1.5"/>

        {/* Angle of wrap for crossed */}
        <text x={680} y={222} textAnchor="middle" fontSize="9" fill="#7a4a28">Wrap angle α = 180° + 2sin⁻¹((D+d)/2C)</text>

        {/* Wear warning */}
        <rect x={580} y={238} width={210} height={16} rx={3} fill="#fff3cd" stroke="#c8a400"/>
        <text x={685} y={250} textAnchor="middle" fontSize="9" fill="#7a5c00">⚠ Belt wears faster at crossing point</text>
      </svg>
      <div style={S.dCaption}>Crossed belt achieves reversal without extra idler pulleys — but increases belt wear and limits shaft centre distance</div>
    </div>
  );
}

// ── Diagram: Torque & Power Relationships ────────────────────────────
function DiagramTorquePower() {
  const W = 900, H = 300;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Torque, Power & Tension Relationships in a Belt Drive</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowTP" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
          <marker id="arrowTPred" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrowTPblue" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2e5ba8"/>
          </marker>
        </defs>

        {/* Driver pulley */}
        <circle cx={200} cy={150} r={60} fill="#c45a10" opacity="0.8" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={200} cy={150} r={16} fill="#fdf4ec" stroke="#a04010" strokeWidth="2"/>
        <text x={200} y={146} textAnchor="middle" fontSize="13" fontWeight="700" fill="#fff">Driver</text>
        <text x={200} y={162} textAnchor="middle" fontSize="10" fill="#f5d9be">R₁</text>

        {/* Driven pulley */}
        <circle cx={620} cy={150} r={40} fill="#d4874a" opacity="0.8" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={620} cy={140} r={11} fill="#fdf4ec" stroke="#a04010" strokeWidth="2"/>
        <text x={620} y={152} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">Driven</text>
        <text x={620} y={165} textAnchor="middle" fontSize="10" fill="#f5d9be">R₂</text>

        {/* Tight side (top) — high tension T₁ */}
        <line x1={200} y1={90} x2={620} y2={110} stroke="#c0392b" strokeWidth="4" markerEnd="url(#arrowTPred)"/>
        <rect x={350} y={70} width={110} height={30} rx={4} fill="#fdecea" stroke="#c0392b"/>
        <text x={405} y={84} textAnchor="middle" fontSize="10" fontWeight="700" fill="#c0392b">Tight side T₁</text>
        <text x={405} y={97} textAnchor="middle" fontSize="9" fill="#c0392b">High tension</text>

        {/* Slack side (bottom) — low tension T₂ */}
        <line x1={620} y1={190} x2={200} y2={210} stroke="#2e5ba8" strokeWidth="4" markerEnd="url(#arrowTPblue)"/>
        <rect x={350} y={215} width={110} height={30} rx={4} fill="#e8eef8" stroke="#2e5ba8"/>
        <text x={405} y={229} textAnchor="middle" fontSize="10" fontWeight="700" fill="#2e5ba8">Slack side T₂</text>
        <text x={405} y={242} textAnchor="middle" fontSize="9" fill="#2e5ba8">Low tension</text>

        {/* Torque arrows */}
        <path d="M 160 92 A 62 62 0 0 1 260 108" fill="none" stroke="#c45a10" strokeWidth="2" markerEnd="url(#arrowTP)"/>
        <text x={165} y={76} fontSize="10" fontWeight="700" fill="#7a2e00">τ_in = (T₁−T₂)×R₁</text>

        <path d="M 658 118 A 42 42 0 0 1 658 182" fill="none" stroke="#c45a10" strokeWidth="2" markerEnd="url(#arrowTP)"/>
        <text x={665} y={152} fontSize="10" fontWeight="700" fill="#7a2e00">τ_out = (T₁−T₂)×R₂</text>

        {/* Formula box */}
        <rect x={20} y={255} width={860} height={35} rx={4} fill="#fdf0e4" stroke="#c45a10"/>
        <text x={450} y={270} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">
          Power: P = (T₁ − T₂) × v    where v = belt speed (m/s) = ω × R
        </text>
        <text x={450} y={283} textAnchor="middle" fontSize="9" fill="#a04010">
          Ratio: T₁/T₂ = e^(μα)   (Euler–Eytelwein equation)  ·  μ = friction coeff  ·  α = angle of wrap (rad)
        </text>

        {/* Centrifugal tension note */}
        <rect x={20} y={12} width={400} height={22} rx={3} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={220} y={27} textAnchor="middle" fontSize="9" fill="#7a2e00">At high speeds: effective tension = T₁ − T_c where T_c = mv² (centrifugal tension)</text>
      </svg>
      <div style={S.dCaption}>Net driving force = T₁ − T₂ · Power is constant along belt (neglecting losses) · Tight side is on the side the belt leaves the driver</div>
    </div>
  );
}

// ── Diagram: Compound Stepped Pulley (Cone Pulley) ───────────────────
function DiagramSteppedPulley() {
  const W = 900, H = 420;

  const steps = [
    { r1: 60, r2: 20 },
    { r1: 45, r2: 32 },
    { r1: 30, r2: 45 },
    { r1: 18, r2: 58 },
  ];

  const cx1 = 250, cx2 = 640;
  // 4 steps × 75px gap starting at y=45 → last step at y=45+3×75=270; baseY below that
  const stepGap = 75;
  const firstY = 45;
  const lastY = firstY + (steps.length - 1) * stepGap; // 270
  const baseY = lastY + 55; // 325 — ground line well below last ellipse

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stepped (Cone) Pulley — Variable Speed Ratios via Belt Position</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Shafts — from top to ground line */}
        <line x1={cx1} y1={firstY - 12} x2={cx1} y2={baseY} stroke="#7a2e00" strokeWidth="6"/>
        <line x1={cx2} y1={firstY - 12} x2={cx2} y2={baseY} stroke="#7a2e00" strokeWidth="6"/>

        {/* Ground supports */}
        {[cx1, cx2].map((cx, ci) => (
          <g key={ci}>
            <line x1={cx - 20} y1={baseY} x2={cx + 20} y2={baseY} stroke="#7a2e00" strokeWidth="3"/>
            {[-16,-8,0,8,16].map((dx, j) => (
              <line key={j} x1={cx + dx} y1={baseY} x2={cx + dx - 6} y2={baseY + 10}
                stroke="#7a2e00" strokeWidth="1.5"/>
            ))}
          </g>
        ))}

        {/* Cone labels */}
        <text x={cx1} y={baseY + 28} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Driver Cone</text>
        <text x={cx2} y={baseY + 28} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">Driven Cone</text>

        {steps.map((s, i) => {
          const yCenter = firstY + i * stepGap;
          const isActive = i === 1;

          return (
            <g key={i}>
              {/* Driver pulley ellipse */}
              <ellipse cx={cx1} cy={yCenter} rx={s.r1} ry={12}
                fill={isActive ? '#c45a10' : '#e8b07a'} opacity="0.85"
                stroke="#7a2e00" strokeWidth={isActive ? 2.5 : 1.5}/>
              <text x={cx1 - s.r1 - 6} y={yCenter + 4} textAnchor="end" fontSize="9"
                fill="#7a2e00" fontFamily="'Courier New',monospace">r={s.r1}mm</text>

              {/* Driven pulley ellipse */}
              <ellipse cx={cx2} cy={yCenter} rx={s.r2} ry={12}
                fill={isActive ? '#c45a10' : '#e8b07a'} opacity="0.85"
                stroke="#7a2e00" strokeWidth={isActive ? 2.5 : 1.5}/>
              <text x={cx2 + s.r2 + 6} y={yCenter + 4} textAnchor="start" fontSize="9"
                fill="#7a2e00" fontFamily="'Courier New',monospace">r={s.r2}mm</text>

              {/* Belt lines */}
              <line x1={cx1 - s.r1} y1={yCenter - 12} x2={cx2 - s.r2} y2={yCenter - 12}
                stroke={isActive ? '#c45a10' : '#f0cfa0'} strokeWidth={isActive ? 4 : 2}
                strokeDasharray={isActive ? 'none' : '4,3'}/>
              <line x1={cx1 + s.r1} y1={yCenter + 12} x2={cx2 + s.r2} y2={yCenter + 12}
                stroke={isActive ? '#c45a10' : '#f0cfa0'} strokeWidth={isActive ? 4 : 2}
                strokeDasharray={isActive ? 'none' : '4,3'}/>

              {/* Speed ratio label box — centred between shafts */}
              <rect x={420} y={yCenter - 14} width={150} height={30} rx={4}
                fill={isActive ? '#fdf0e4' : '#fdf6ee'} stroke={isActive ? '#c45a10' : '#e8c89a'}/>
              <text x={495} y={yCenter + 1} textAnchor="middle" fontSize="9"
                fontWeight={isActive ? '700' : '400'} fill={isActive ? '#7a2e00' : '#7a4a28'}>
                {`VR = ${s.r1}/${s.r2} = ${(s.r1/s.r2).toFixed(2)}`}
              </text>
              <text x={495} y={yCenter + 13} textAnchor="middle" fontSize="8" fill="#7a4a28">
                {s.r1 > s.r2 ? 'speed reduction' : s.r1 < s.r2 ? 'speed increase' : 'direct drive'}
              </text>

              {/* Active belt badge — placed inside SVG to the right of driven label */}
              {isActive && (
                <g>
                  <rect x={cx2 + 70} y={yCenter - 14} width={88} height={24} rx={3} fill="#c45a10" opacity="0.9"/>
                  <text x={cx2 + 114} y={yCenter + 2} textAnchor="middle" fontSize="9" fontWeight="700" fill="#fff">Active Belt</text>
                </g>
              )}
            </g>
          );
        })}

        {/* Note line at bottom with plenty of room */}
        <text x={W/2} y={baseY + 52} textAnchor="middle" fontSize="9" fill="#888" fontStyle="italic">
          Moving belt to different step changes speed ratio — classic manual gearbox concept for machine tools
        </text>
      </svg>
      <div style={S.dCaption}>Stepped pulleys allow discrete speed changes without stopping: each belt position gives a different output speed</div>
    </div>
  );
}

// ── Diagram: Efficiency & Power Loss ────────────────────────────────
function DiagramEfficiency() {
  const W = 900, H = 240;

  const losses = [
    { label: 'Creep', pct: 2.5, desc: 'Elastic deformation of belt under tension difference', x: 80 },
    { label: 'Slip', pct: 2.0, desc: 'Gross sliding when belt overloaded or too loose', x: 245 },
    { label: 'Bending', pct: 1.5, desc: 'Repeated flexing over pulley adds heat', x: 410 },
    { label: 'Windage', pct: 0.8, desc: 'Air resistance at high belt speeds', x: 575 },
    { label: 'Bearing', pct: 0.7, desc: 'Shaft bearing friction losses', x: 720 },
  ];

  const maxPct = 5;
  const barH = 100, barW = 80, barBase = 155;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Power Loss Sources in Belt Drives — Typical Percentage Losses</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Bars */}
        {losses.map((l, i) => {
          const h = (l.pct / maxPct) * barH;
          return (
            <g key={i}>
              <rect x={l.x} y={barBase - h} width={barW} height={h}
                fill="#c45a10" opacity={0.6 + i*0.07} rx={3}/>
              <text x={l.x + barW/2} y={barBase - h - 6} textAnchor="middle"
                fontSize="11" fontWeight="700" fill="#7a2e00">{l.pct}%</text>
              <text x={l.x + barW/2} y={barBase + 14} textAnchor="middle"
                fontSize="10" fontWeight="700" fill="#a04010">{l.label}</text>
              <text x={l.x + barW/2} y={barBase + 26} textAnchor="middle"
                fontSize="8" fill="#7a4a28" style={{maxWidth:'80px'}}></text>
              {/* description - wrapped manually */}
              {l.desc.match(/.{1,18}(\s|$)/g)?.map((line, li) => (
                <text key={li} x={l.x + barW/2} y={barBase + 26 + li * 12}
                  textAnchor="middle" fontSize="7.5" fill="#7a4a28">{line.trim()}</text>
              ))}
            </g>
          );
        })}

        {/* Axis */}
        <line x1={55} y1={55} x2={55} y2={barBase} stroke="#e8b07a" strokeWidth="1.5"/>
        <line x1={55} y1={barBase} x2={860} y2={barBase} stroke="#e8b07a" strokeWidth="1.5"/>
        {[0,1,2,3,4,5].map((v, i) => {
          const y = barBase - (v / maxPct) * barH;
          return (
            <g key={i}>
              <line x1={50} y1={y} x2={860} y2={y} stroke="#e8c89a" strokeWidth="0.7" strokeDasharray="3,3"/>
              <text x={48} y={y + 4} textAnchor="end" fontSize="8" fill="#888">{v}%</text>
            </g>
          );
        })}

        {/* Efficiency banner */}
        <rect x={30} y={10} width={840} height={28} rx={4} fill="#fdf0e4" stroke="#c45a10"/>
        <text x={450} y={22} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">
          Total typical loss ≈ 2–4% ·  Belt drive efficiency ≈ 96–98%  ·  Creep is unavoidable even in well-tensioned drives
        </text>
        <text x={450} y={33} textAnchor="middle" fontSize="9" fill="#a04010">
          η = P_out / P_in = (τ_out × ω_out) / (τ_in × ω_in)
        </text>
      </svg>
      <div style={S.dCaption}>Belt drives are among the most efficient mechanical power transmission methods — creep is the dominant unavoidable loss</div>
    </div>
  );
}

// ── Diagram: Centre Distance & Belt Length ───────────────────────────
function DiagramCentreDistance() {
  const W = 960, H = 260;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Centre Distance, Belt Length & Angle of Contact</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowCD" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#a04010"/>
          </marker>
        </defs>

        {/* Large driver pulley */}
        <circle cx={200} cy={125} r={65} fill="#c45a10" opacity="0.7" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={200} cy={125} r={16} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={200} y={130} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">D</text>

        {/* Small driven pulley — moved to x=580 so label "r = d/2" fits before formula panel at x=630 */}
        <circle cx={560} cy={125} r={38} fill="#d4874a" opacity="0.7" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={560} cy={125} r={11} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={560} y={130} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">d</text>

        {/* Belt tangents (approximate open belt) */}
        <line x1={197} y1={60} x2={557} y2={87} stroke="#c45a10" strokeWidth="3.5"/>
        <line x1={197} y1={190} x2={557} y2={163} stroke="#c45a10" strokeWidth="3.5"/>

        {/* Centre distance annotation */}
        <line x1={200} y1={215} x2={560} y2={215}
          stroke="#a04010" strokeWidth="1.5"
          markerStart="url(#arrowCD)" markerEnd="url(#arrowCD)"/>
        <rect x={334} y={205} width={92} height={20} rx={3} fill="#fdf0e4" stroke="#e8b07a"/>
        <text x={380} y={219} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7a2e00">C (centre dist.)</text>

        {/* Radius annotations — both labels left of their lines to avoid overlap */}
        <line x1={200} y1={125} x2={200} y2={60} stroke="#e8b07a" strokeWidth="1" strokeDasharray="3,2"/>
        <text x={155} y={90} fontSize="9" fill="#a04010">R = D/2</text>

        <line x1={560} y1={125} x2={560} y2={87} stroke="#e8b07a" strokeWidth="1" strokeDasharray="3,2"/>
        <text x={516} y={105} fontSize="9" fill="#a04010" textAnchor="end">r = d/2</text>

        {/* Formula panel — starts at x=630, ends at x=950 */}
        <rect x={630} y={15} width={320} height={200} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={790} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Belt Length Formula</text>
        <line x1={640} y1={43} x2={942} y2={43} stroke="#e8b07a"/>
        {[
          'L = 2C + π(D+d)/2',
          '    + (D−d)²/(4C)',
          '',
          'Angle of wrap (driver):',
          'α = 180° − 2sin⁻¹((D−d)/2C)',
          '',
          'Min. recommended wrap:',
          'α ≥ 120° for good grip',
          '',
          'Minimum centre distance:',
          'C > (D + d) / 2',
          '(to avoid belt fouling)',
        ].map((line, i) => (
          <text key={i} x={642} y={57 + i * 13}
            fontSize={i===0||i===3||i===6||i===9?'9.5':'9'}
            fontWeight={i===0||i===3||i===6||i===9?'700':'400'}
            fill={i===0?'#7a2e00':'#a04010'}
            fontFamily="'Courier New', monospace">{line}</text>
        ))}
      </svg>
      <div style={S.dCaption}>Larger centre distance reduces bending stress and increases belt life — but adds weight and vibration risk</div>
    </div>
  );
}

// ── Diagram: Idler Pulley & Tensioning ──────────────────────────────
function DiagramIdler() {
  const W = 900, H = 310;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Idler Pulley — Belt Tensioning and Slack-Side Control</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="arrowID" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c45a10"/>
          </marker>
        </defs>

        {/* Driver pulley */}
        <circle cx={130} cy={120} r={50} fill="#c45a10" opacity="0.8" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={130} cy={120} r={13} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        {/* Labels outside the circle */}
        <text x={130} y={56} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Driver</text>
        <text x={130} y={124} textAnchor="middle" fontSize="10" fill="#fff">D</text>
        {/* CW rotation arrow */}
        <path d="M 130 68 A 52 52 0 0 1 182 120" fill="none" stroke="#e8b07a" strokeWidth="1.5" markerEnd="url(#arrowID)"/>

        {/* Driven pulley */}
        <circle cx={560} cy={120} r={38} fill="#d4874a" opacity="0.8" stroke="#7a2e00" strokeWidth="2.5"/>
        <circle cx={560} cy={120} r={11} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={560} y={68} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Driven</text>
        <text x={560} y={124} textAnchor="middle" fontSize="10" fill="#fff">d</text>

        {/* Idler pulley — lower, giving room for spring below */}
        <circle cx={345} cy={230} r={22} fill="#e8b07a" opacity="0.85" stroke="#a04010" strokeWidth="2"/>
        <circle cx={345} cy={230} r={7} fill="#fdf4ec" stroke="#a04010" strokeWidth="1.5"/>
        <text x={345} y={234} textAnchor="middle" fontSize="8" fontWeight="700" fill="#7a2e00">Idler</text>
        <text x={300} y={234} textAnchor="middle" fontSize="9" fontWeight="700" fill="#a04010">Idler</text>

        {/* Spring below idler */}
        <line x1={345} y1={252} x2={345} y2={263} stroke="#a04010" strokeWidth="2"/>
        {/* zigzag spring */}
        {[0,1,2,3,4].map(j => (
          <line key={j}
            x1={345 + (j%2===0 ? -6 : 6)} y1={263 + j*5}
            x2={345 + (j%2===0 ? 6 : -6)} y2={263 + (j+1)*5}
            stroke="#a04010" strokeWidth="1.5"/>
        ))}
        <line x1={345} y1={288} x2={345} y2={296} stroke="#a04010" strokeWidth="2"/>
        <line x1={328} y1={296} x2={362} y2={296} stroke="#7a2e00" strokeWidth="2.5"/>
        <text x={345} y={307} textAnchor="middle" fontSize="8" fill="#7a2e00">spring tensioner</text>

        {/* Tight side (top) */}
        <line x1={130} y1={70} x2={560} y2={82} stroke="#c0392b" strokeWidth="3.5"/>
        <text x={345} y={62} textAnchor="middle" fontSize="10" fontWeight="700" fill="#c0392b">Tight side T₁</text>

        {/* Slack side with idler deflection */}
        <line x1={130} y1={170} x2={323} y2={218} stroke="#2e5ba8" strokeWidth="3.5"/>
        <line x1={367} y1={218} x2={560} y2={158} stroke="#2e5ba8" strokeWidth="3.5"/>
        <text x={215} y={210} textAnchor="middle" fontSize="9" fontWeight="700" fill="#2e5ba8">Slack side T₂</text>

        {/* Tension force arrow on idler */}
        <line x1={345} y1={208} x2={345} y2={190} stroke="#a04010" strokeWidth="2" markerEnd="url(#arrowID)"/>
        <text x={358} y={202} fontSize="9" fill="#7a2e00">F_tension</text>

        {/* Info panel — fits within W=900 */}
        <rect x={625} y={25} width={265} height={215} rx={6} fill="#fdf0e4" stroke="#c45a10" strokeWidth="1.5"/>
        <text x={757} y={45} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a2e00">Idler Functions</text>
        <line x1={635} y1={52} x2={882} y2={52} stroke="#e8b07a"/>
        {[
          '► Maintain belt tension',
          '► Increase wrap angle on',
          '   small pulleys',
          '► Take up belt stretch',
          '   over service life',
          '► Enable reverse bending',
          '   (increases bending loss)',
          '► Allow fixed shaft',
          '   centre distances',
          '',
          'Best placed on slack side',
          'Inside face of belt preferred',
        ].map((line, i) => (
          <text key={i} x={638} y={65 + i * 13} fontSize="9"
            fill={i===10||i===11?'#7a2e00':'#a04010'}
            fontWeight={i===10||i===11?'700':'400'}>{line}</text>
        ))}
      </svg>
      <div style={S.dCaption}>Idler pulleys on the slack side increase the angle of wrap on both driver and driven pulleys, improving power transmission capacity</div>
    </div>
  );
}

// ── Main export ──────────────────────────────────────────────────────
export default function SeriesPulleys() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Series Pulleys in Mechanical Engineering</h1>
         <p>
                        A pulley system is an assembly between a spinning wheel and rope that is designed to transfer power and/or gather 
                        mechanical advantage through this exchange. Mechanical advantage describes a process of trading one or more 
                        characteristics for another deemed more valuable for the situation. In the case of pulleys, by adding additional pulleys 
                        to the exchange, a designer can trade additional distance rotated for increases in torsion. Unlike belt and chain drives,
                         the pulley itself acts more as a guide for the rope and provides support for the mechanism.                     
                         <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={PulleysImg} alt="pulley" width="75%"/>
                                </div>
                        </p>
      <p style={S.p}>
        A <strong>series (or compound) pulley system</strong> uses two or more belt-and-pulley stages arranged in sequence,
        where the output shaft of one stage is the input shaft of the next. This configuration allows very large speed ratios
        or torque multiplications to be achieved that would be impractical with a single stage, while keeping individual
        pulley sizes manageable. Series pulley arrangements are foundational in machine tools, industrial drives, textile
        machinery, and agricultural equipment.
      </p>

      <InfoBox title="Quick Reference — Core Concepts" items={[
        "Velocity Ratio (VR): ratio of driver speed to driven speed = D_driver / D_driven = ω_in / ω_out",
        "Series system: VR_total = VR₁ × VR₂ × VR₃ × … (individual stage ratios multiply)",
        "Power conservation: P_in ≈ P_out (minus losses) — increasing torque means decreasing speed",
        "Belt tension: Tight side T₁ > Slack side T₂ · Net force = T₁ − T₂ · Ratio T₁/T₂ = e^(μα)",
        "Efficiency: belt drives typically 96–98% efficient per stage",
        "Minimum centre distance: C > (D + d)/2 to prevent belt fouling the pulleys",
      ]}/>

      <h2 style={S.h2}>System Overview</h2>
      <p style={S.p}>
        In a series system, each intermediate shaft carries two pulleys — one that receives drive from the upstream belt and one
        that transmits drive to the downstream belt. The shafts are supported in bearings fixed to a frame. Because the pulleys
        on a common shaft rotate at the same speed, the velocity ratio of each stage compounds multiplicatively into the overall ratio.
      </p>
      <DiagramSeriesOverview />

      <h2 style={S.h2}>Velocity Ratio & Speed Calculations</h2>
      <p style={S.p}>
        The fundamental relationship of a belt drive is that belt speed is equal on both sides: <code>v = ω₁R₁ = ω₂R₂</code>.
        This directly gives the velocity ratio as the inverse of the pulley radius ratio. For a series arrangement, ratios multiply
        because intermediate shaft speeds cancel through — only input and output speed (and all pulley diameters) matter.
      </p>
      <DiagramVelocityRatio />
      <Table2 rows={[
        ["Velocity Ratio (VR)", "VR = N_driver / N_driven = D_driven / D_driver\nFor series: VR_total = (D₂/D₁) × (D₄/D₃) × …\nVR > 1: speed reduction · VR < 1: speed increase"],
        ["Speed of driven shaft", "N_out = N_in / VR_total\nExamples: 3 stages of VR=2 each → VR_total = 8 → N_out = N_in / 8"],
        ["Torque relationship", "τ_out = τ_in × VR × η_total\nHigher VR → lower speed → proportionally higher torque output"],
        ["Slip effect", "Actual VR = VR_theoretical × (1 − s) where s = fractional slip (typical 1–3%)\nN_out = N_in × (D_driver/D_driven) × (1 − s)"],
        ["Intermediate shaft speed", "N₂ = N₁ × (D₁/d₁)  →  N₃ = N₂ × (D₂/d₂)\nIntermediate shafts must be designed for the torques and speeds they actually carry"],
        ["Belt speed (v)", "v = π × D × N / 60 000  (D in mm, N in rpm → v in m/s)\nTypical range: 5–25 m/s for flat belts · up to 30 m/s for V-belts"],
      ]}/>

      <h2 style={S.h2}>Belt Types</h2>
      <p style={S.p}>
        The choice of belt cross-section determines efficiency, slip characteristics, maximum speed, and whether the drive
        is synchronous. Series drives may use different belt types on each stage if power levels or slip requirements differ.
      </p>
      <DiagramBeltTypes />

      <h2 style={S.h2}>Open vs Crossed Belt Arrangements</h2>
      <p style={S.p}>
        Within a series system, each stage may independently use an open belt (shafts rotate the same direction) or a crossed
        belt (shafts rotate in opposite directions). Alternating open and crossed stages can achieve any desired output rotation
        direction without a separate reversing mechanism.
      </p>
      <DiagramBeltArrangement />
      <Table2 rows={[
        ["Open belt drive", "Both pulleys rotate in the same direction\nBelt length: L = 2C + π(D+d)/2 + (D−d)²/(4C)\nSmaller angle of wrap on the smaller pulley"],
        ["Crossed belt drive", "Pulleys rotate in opposite directions\nBelt length: L = 2C + π(D+d)/2 + (D+d)²/(4C)\nLarger angle of wrap on both pulleys — better grip"],
        ["Crossed belt wear", "Belt crosses over itself at the midpoint, causing friction\nSuitable only for large centre distances and moderate speeds"],
        ["Angle of contact", "Open belt on small pulley: α = 180° − 2sin⁻¹((D−d)/2C)\nCrossed belt: α = 180° + 2sin⁻¹((D+d)/2C)\nLarger α → greater maximum transmissible force"],
      ]}/>

      <h2 style={S.h2}>Torque, Power & Belt Tension</h2>
      <p style={S.p}>
        The transmitted power depends on the net belt tension (tight side minus slack side) and the belt velocity.
        The Euler–Eytelwein equation governs the maximum ratio of tensions before the belt slips, making friction
        coefficient and angle of wrap the critical design parameters.
      </p>
      <DiagramTorquePower />
      <Table2 rows={[
        ["Euler–Eytelwein equation", "T₁/T₂ = e^(μα)  where μ = coefficient of friction, α = wrap angle in radians\nFor V-belt: effective μ = μ_groove / sin(β/2) — wedge action amplifies friction\nTypical μ: leather on iron 0.3–0.5 · rubber on iron 0.4–0.6"],
        ["Transmitted power", "P = (T₁ − T₂) × v  (watts, if T in N and v in m/s)\nEquivalently: P = τ × ω = F_net × v"],
        ["Initial tension T₀", "T₀ = (T₁ + T₂) / 2  — pre-tension with no load\nInsufficient T₀ → belt slips · Excess T₀ → high bearing loads"],
        ["Centrifugal tension", "T_c = m × v²  (m = mass per unit length of belt, kg/m)\nReduces effective grip: (T₁ − T_c) / (T₂ − T_c) = e^(μα)\nDominates at high speed — there is an optimal speed for max power"],
        ["Maximum power speed", "dP/dv = 0 → v_opt = √(T₀ / (3m))  (open belt approximation)\nTypically 15–22 m/s for flat belts"],
        ["Bearing load", "Total shaft load = T₁ + T₂ (vector sum, ≈ T₁ + T₂ for near-parallel tensions)\nMust size bearings for both radial load and fatigue life"],
      ]}/>

      <h2 style={S.h2}>Stepped (Cone) Pulley — Variable Ratio</h2>
      <p style={S.p}>
        A stepped pulley is a coaxial stack of pulleys with increasing radii, paired with a matching stepped pulley on the driven
        shaft whose steps decrease in radius. Moving the belt to a different step pair changes the velocity ratio discretely.
        This was the standard speed-change mechanism on lathes, drill presses, and milling machines before electronic variable-speed
        drives became prevalent.
      </p>
      <DiagramSteppedPulley />
      <Table2 rows={[
        ["Design constraint", "For each belt position i: D_i + d_i = constant\nEnsures the same belt length fits all positions without adjustment"],
        ["Number of steps", "Typically 3–6 speeds; more steps require longer shaft and wider frame\nSpeed range ratio (highest/lowest) determines spread of step diameters"],
        ["Geometric progression", "Step diameters often follow a geometric series: D_n = D₁ × φ^(n−1)\nφ (step ratio) typically 1.06 to 1.41 per standard R5–R20 series"],
        ["Material of cone pulleys", "Cast iron for heavy-duty lathes · Aluminium for light-duty\nBelt: flat leather or rubber for cone pulleys (V-belts require matching grooves)"],
        ["Shifting belt", "Machine must be stopped or slowed to shift belt between steps safely\nException: some designs use a jockey or lever to shift under partial load"],
      ]}/>

      <h2 style={S.h2}>Centre Distance, Belt Length & Geometry</h2>
      <DiagramCentreDistance />
      <Table2 rows={[
        ["Open belt length", "L = 2C + π(D+d)/2 + (D−d)²/(4C)\nC = centre distance · D, d = pulley diameters"],
        ["Crossed belt length", "L = 2C + π(D+d)/2 + (D+d)²/(4C)\nNote: D+d (not D−d) — crossed belt is always longer than open for same pulleys"],
        ["Recommended centre distance", "C_min ≈ 1.5 × (D + d)  ·  C_max ≈ 4 × (D + d) for standard flat belts\nLarger C: less bending stress, more span oscillation risk"],
        ["Belt sag (catenary)", "Belt sag under gravity can cause vibration at natural frequency\nf_natural = (1/L) × √(T₀/m) — should not match belt frequency at running speed"],
        ["Pulley alignment tolerance", "Angular misalignment: < 0.5° between shaft axes for flat/V-belts\nParallel offset: < 1 mm per 100 mm of belt width"],
        ["V-belt centre distance", "C ≈ (b + √(b² − 8(D−d)²)) / 4  where b = 4L − 2π(D+d)\nStandard V-belt series A,B,C,D,E each have fixed cross-sections"],
      ]}/>

      <h2 style={S.h2}>Idler Pulleys & Tensioning</h2>
      <p style={S.p}>
        Maintaining correct belt tension over the service life is critical. Belts stretch with use, and insufficient tension
        allows slip while excessive tension overloads bearings. Idler pulleys or adjustable shaft centres are the two standard
        tensioning methods; idlers are especially common when shaft positions are fixed.
      </p>
      <DiagramIdler />
      <Table2 rows={[
        ["Spring-loaded idler", "Constant tension regardless of belt elongation · Self-adjusting\nIdler pressed onto slack side by spring or deadweight — most common method"],
        ["Adjustable centre", "One shaft mounted on slideable rails or pivot bracket\nSimple and reliable; common on lathes and drill presses"],
        ["Jockey pulley position", "Slack side is preferred — does not reduce angle of wrap on main pulleys\nInside face of belt (non-working face) minimises reverse bending stress"],
        ["Over-tensioning effects", "Excessive T₀: accelerates bearing wear, increases bending fatigue, causes heat\nRule of thumb: belt should deflect ~15 mm per metre of span under light thumb pressure"],
        ["Under-tensioning effects", "Belt slips → gross sliding → rapid wear and heat generation\nSlip also corrupts velocity ratio — critical in precision machine tools"],
      ]}/>

      <h2 style={S.h2}>Efficiency & Power Losses</h2>
      <DiagramEfficiency />
      <Table2 rows={[
        ["Creep loss", "Non-elastic stretch difference between tight and slack sides causes microscopic belt surface creep\nCannot be eliminated — fundamental to friction drive; accounts for ~1–2% loss per stage"],
        ["Slip loss", "Gross sliding when belt is overloaded (T₁/T₂ > e^μα)\nAvoided by proper tensioning and not exceeding rated power"],
        ["Bending loss", "Repeated flex cycles dissipate energy as heat — more severe with small pulleys\nMinimum pulley diameter guideline: D_min = 20 × belt thickness (flat belt)"],
        ["Windage (aerodynamic)", "Significant only at high belt speeds > 20 m/s; belt whips air around pulleys\nEnclosed guards help — also reduce noise"],
        ["Stage efficiency", "Each stage typically 96–98% efficient\nTwo-stage series system: η_total = η₁ × η₂ ≈ 0.97 × 0.97 ≈ 0.94 (94%)"],
        ["Improving efficiency", "Keep belt speed near optimal · use V-belts or timing belts · minimise number of stages\nLubrication of bearings critical · correct initial tension · alignment within tolerances"],
      ]}/>

      <h2 style={S.h2}>Design Procedure for a Series Belt Drive</h2>
      <Table2 rows={[
        ["Step 1 — Define requirements", "Input speed N_in, output speed N_out, power P, space envelope, environment\nDetermine acceptable number of stages (typically 2–4)"],
        ["Step 2 — Allocate stage ratios", "Aim for equal stage ratios: VR_stage = VR_total^(1/n) for n stages\nKeep any individual stage VR between 1:6 and 6:1 to limit pulley size disparity"],
        ["Step 3 — Select belt type", "Flat: long centre distances, high speed, lower grip\nV-belt: compact, higher power density, widely standardised (ISO 22)\nTiming belt: synchronous, precision, low maintenance"],
        ["Step 4 — Size pulleys", "Choose smallest pulley diameter ≥ D_min (from belt standard or bending stress limit)\nScale up driver or driven pulley to achieve required VR"],
        ["Step 5 — Determine belt length & C", "Use belt length formula; round to nearest standard belt length\nRecalculate actual C for the chosen standard belt"],
        ["Step 6 — Check tensions", "Calculate T₁, T₂ from P, v, μ, α\nVerify T₁/T₂ ≤ e^(μα) with margin · set initial tension T₀"],
        ["Step 7 — Size shafts & bearings", "Intermediate shafts carry combined torque from both pulleys\nBearing loads = vector sum of T₁ + T₂ on each pulley · check L₁₀ fatigue life"],
        ["Step 8 — Verify power & efficiency", "P_out = P_in × η₁ × η₂ × … · check each intermediate shaft for adequate power"],
      ]}/>

      <h2 style={S.h2}>Applications of Series Pulley Systems</h2>
      <Table2 rows={[
        ["Lathe headstock", "Stepped cone pulleys provide 6–12 discrete spindle speeds without gearbox\nMain belt: high-speed flat/V-belt · Back-gear lever for extra low speeds"],
        ["Drill press", "Two-stage V-belt drive gives 5–12 speeds · manual belt shifting\nLow gear for hard materials, high gear for small drills in soft materials"],
        ["Textile machinery", "Multiple series stages drive looms, carding machines at precise low speeds\nHigh torque multiplication from motor speed to ~20–100 rpm output"],
        ["Agricultural equipment", "Combine harvesters use series belt drives for threshing drum, header, augers\nV-belts preferred for shock absorption with sticky crops and soil ingestion"],
        ["Industrial fans/blowers", "Two-stage drive allows motor to run at standard speed while fan optimised for duty\nSingle stage usually sufficient unless very large speed change needed"],
        ["Clock and instrument drives", "Round belts or timing belts in series for precise angular positioning\nNo-slip timing belts critical where angle relationship must be maintained"],
      ]}/>

      <h2 style={S.h2}>Failure Modes & Maintenance</h2>
      <Table2 rows={[
        ["Belt fatigue cracking", "Repeated bending over pulleys causes transverse cracks on inner face\nCheck: any crack penetrating > 50% of thickness → replace immediately"],
        ["Belt wear (face glazing)", "Smooth, shiny belt surface → reduced friction → slipping at rated load\nCause: over-tensioning, contamination with oil, or pulley misalignment"],
        ["Belt stretching", "Gradual elongation reduces tension → increased slip and vibration\nFix: re-tension via adjustable centre or replace belt when slack side becomes loose"],
        ["Pulley wear (V-groove)", "Worn grooves allow belt to sink deeper → bottom of belt contacts groove base\nResult: friction and drive characteristics change; replace pulley or re-groove"],
        ["Shaft misalignment", "Most common cause of premature failure; causes uneven tension across belt width\nCheck with straight-edge across pulley faces; correct to < 0.5° and < 1 mm offset"],
        ["Inspection intervals", "Check tension and alignment every 500–1000 operating hours or quarterly\nInspect belt surface for cracks, fraying, oil contamination, glazing"],
        ["Oil contamination", "Oil reduces friction drastically → severe slip\nSeal leaking shaft seals; clean belt and pulleys with solvent before returning to service"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Velocity Ratio: VR = D_driven / D_driver = N_driver / N_driven",
        "Series VR: VR_total = VR₁ × VR₂ × … × VRₙ",
        "Belt speed: v = π·D·N / 60 000  (D in mm, N in rpm → v in m/s)",
        "Euler–Eytelwein: T₁/T₂ = e^(μα)  [flat belt]  ·  T₁/T₂ = e^(μα/sinβ)  [V-belt, β = half groove angle]",
        "Transmitted power: P = (T₁ − T₂) × v  [W]",
        "Torque on shaft: τ = (T₁ − T₂) × R  [N·m]",
        "Centrifugal tension: T_c = m·v²  [m = belt mass/length in kg/m]",
        "Open belt length: L = 2C + π(D+d)/2 + (D−d)²/(4C)",
        "Crossed belt length: L = 2C + π(D+d)/2 + (D+d)²/(4C)",
        "Wrap angle (open, small pulley): α = π − 2sin⁻¹((D−d)/2C)  [radians]",
        "Efficiency per stage: η ≈ 0.96–0.98  ·  η_total = η₁ × η₂ × …",
        "Max power speed: v_opt = √(T₀ / 3m)  (open flat belt approximation)",
      ]}/>
    </div>
  );
}